export default __webpack_public_path__ + "static/media/hackerrank.057c3426.svg";